"use client"
import React from 'react';
import './preloader.css';

export default function Preloader() {
  return (
    <>
    <div className="preloader">
        <div className="bgGrid"></div>
        <div className="book">
        </div>
    </div>
    </>
  )
}